import React, { useState, useEffect, useRef } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { Button, Drawer, Input, Form } from 'antd'
import notification from 'mrx-notification'
import styles from './CreateSendgridSetting.module.scss'
import { PropsFromRedux, connector } from './container'

const CreateSendgridSetting = (props: PropsFromRedux) => {
  const [isVisible, setVisible] = useState(false)
  const refEl = useRef<Input>(null)

  const { isLoading, createSendgridSetting } = props

  useEffect(() => {
    if (isVisible) {
      refEl.current && refEl.current.focus()
    }
  }, [isVisible])

  const showDrawer = () => {
    setVisible(!isVisible)
  }

  const [form] = Form.useForm()

  const handleClose = () => {
    setVisible(false)
    form.resetFields()
  }

  const onFinishHandler = async (values: any) => {
    const isSaved = await createSendgridSetting({
      name: values.name,
      apiKey: values.apiKey,
      from: values.from,
      fromName: values.fromName
    })
    if (isSaved) {
      notification.success({
        message: 'Successfully',
        description: 'Sendgrid Setting was created successfully!'
      })
      handleClose()
    }
  }

  return (
    <>
      <Button type='primary' onClick={showDrawer}>
        <PlusOutlined />
        CREATE
      </Button>
      <Drawer title='Create Sendgrid Setting' width='400' onClose={handleClose} visible={isVisible} forceRender>
        <Form layout='vertical' hideRequiredMark onFinish={onFinishHandler} form={form}>
          <Form.Item
            name='name'
            label='Name'
            rules={[{ required: true, message: 'Please input sendgrid setting name!' }]}
          >
            <Input ref={refEl} />
          </Form.Item>
          <Form.Item
            name='apiKey'
            label='API Key'
            rules={[{ required: true, message: 'Please input sendgrid setting API key!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='from'
            label='From'
            rules={[{ required: true, message: 'Please input sendgrid setting from email!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='fromName'
            label='From Name'
            rules={[{ required: false, message: 'Please input sendgrid setting from name!' }]}
          >
            <Input />
          </Form.Item>
          <div
            style={{
              position: 'absolute',
              left: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'right'
            }}
          >
            <Button onClick={handleClose} className={styles.createButton}>
              Close
            </Button>
            <Button type='primary' htmlType='submit' loading={isLoading}>
              Create
            </Button>
          </div>
        </Form>
      </Drawer>
    </>
  )
}

export default connector(CreateSendgridSetting)
